<template>
<div>
  <div class="chart">
      <chart-line :data-list="lineData" :xData="xData" :extra-option="option" />
      <chart-line :data-list="lineData2" :xData="xData" :extra-option="option" />
      <chart-line :data-list="pieData" :xData="xData" :extra-option="option" />
  </div>
</div>
</template>

<script>
import ChartLine from "@/components/echarts/echart_line/EchartLine.vue";
import echart from "echarts";
export default {
  components: {
    ChartLine
  },
  data() {
    return {
      echart,
      // 业务数据
      lineData: [{
        name: '预期',
        data: [820, 932, 301, 1434, 1290, 1330, 1320],
        type: 'line',
        smooth: 0.5,// 设置折线弧度，取值：0-1之间
        symbol:'circle',// 设置拐点为实心圆
        symbolSize:6,// 设置折线上圆点大小
        areaStyle: {
          color: new echart.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(187, 157, 255, 0.3)',
          }, {
              offset: 1,
              color: 'rgba(187, 157, 255, 0)'
          }])
        },
      }],
      lineData2: [{
        name: '预期',
        data: [820, 932, 301, 1434, 1290, 1330, 1320],
        type: 'line',
        smooth: 0.5,// 设置折线弧度，取值：0-1之间
        symbol:'circle',// 设置拐点为实心圆
        symbolSize:6,// 设置折线上圆点大小
        areaStyle: {
          color: new echart.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(187, 157, 255, 0.3)',
          }, {
              offset: 1,
              color: 'rgba(187, 157, 255, 0)'
          }])
        },
      },{
        name: '预期2',
        data: [920, 732, 201, 1234, 290, 1330, 120],
        type: 'line',
        smooth: 0.5,// 设置折线弧度，取值：0-1之间
        symbol:'circle',// 设置拐点为实心圆
        symbolSize:6,// 设置折线上圆点大小
        areaStyle: {
          color: new echart.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(88, 213, 171, 0.3)',
          }, {
              offset: 1,
              color: 'rgba(88, 213, 171, 0)',
          }])
        },
      }],
      xData:['1', '2', '3', '4', '5', '6', '7'],
      pieData:[],
      // 定制化配置覆盖默认配置
      option: {
        color:['#BB9DFF','#58D5AB','#FF7989']
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chart{
    width:100%;
    height:320px;
    margin-top:100px;
}
</style>